module.exports = __webpack_public_path__ + "img/comment.33c24d95.svg";